import axiosClient from "./axiosClient";

export const getStaffInfo = () => {
  const url = `/brokers`;
  return axiosClient.get(url);
};

export const getStaffInfoByReferralCode = (referralCode) => {
  const url = `/brokers/referral?code=${referralCode}`;
  return axiosClient.get(url);
};

export const getStaffList = (
  { search, companyIds, sortBy, sortDirection },
  limit = 10,
  page = 1
) => {
  let url = `/brokers/staffList?limit=${limit}&page=${page}`;
  if (search) {
    url += `&q=${encodeURIComponent(search)}`;
  } else {
    url += `&q=`;
  }
  if (companyIds?.length) {
    url += companyIds.map((id) => `&companyIds[]=${id}`).join("");
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDirection) {
    url += `&sortDirection=${encodeURIComponent(sortDirection)}`;
  }
  return axiosClient.get(url);
};

export const checkStaffAliasAvailability = (alias) => {
  const url = `/brokers/check-alias-availability?alias=${encodeURIComponent(
    alias
  )}`;
  return axiosClient.get(url);
};

export const uploadStaffImage = (params) => {
  const url = `/brokers/uploadImage`;
  return axiosClient.post(url, params, {
    headers: {
      ...(params.getHeaders?.() ?? { "Content-Type": "multipart/form-data" }),
    },
  });
};

export const updateStaffDetailsById = (id, params) => {
  const url = `/brokers/${id}`;
  return axiosClient.put(url, params);
};

export const createCompanyAdmin = (createBrokerParams) => {
  const url = `/brokers/createCompanyAdmin`;
  return axiosClient.post(url, createBrokerParams);
};

export const createChildCompanyAdmin = (createBrokerParams) => {
  const url = `/brokers/createChildCompanyAdmin`;
  return axiosClient.post(url, createBrokerParams);
};

export const createCompanyAdminByAdmin = (createBrokerParams) => {
  const url = `/brokers/createCompanyAdminByAdmin`;
  return axiosClient.post(url, createBrokerParams);
};

export const createStaff = (createBrokerParams) => {
  const url = `/brokers/create`;
  return axiosClient.post(url, createBrokerParams);
};

export const deleteStaff = (brokerId) => {
  const url = `/brokers/${brokerId}`;
  return axiosClient.delete(url);
};
